import { render, staticRenderFns } from "./TranslatorOthersTradsOutput.vue?vue&type=template&id=2c25feae&scoped=true"
import script from "./TranslatorOthersTradsOutput.vue?vue&type=script&lang=js"
export * from "./TranslatorOthersTradsOutput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorOthersTradsOutput.vue?vue&type=style&index=0&id=2c25feae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25feae",
  null
  
)

export default component.exports